module.exports = __webpack_public_path__ + "img/pic4.ca91dd26.png";